<template>
  <div class="war-room-post-preview-image">
    <NuxtImg
      v-if="post.cover_url"
      width="62"
      height="62"
      alt=""
      :src="post.cover_url"
      class="war-room-post-preview-image__picture"
      fit="fill"
      :modifiers="{ gravity: 'auto' }"
      loading="lazy"
    />
    <LinkedInIcon v-if="isLinkedin" class="war-room-post-preview-image__icon" />
    <VideoIcon v-else-if="isYoutube" class="war-room-post-preview-image__icon" />
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import VideoIcon from './images/video.vue.svg';
import LinkedInIcon from './images/linkedin.vue.svg';
import type { IPost } from '@/types/community';
import { postTypes } from '~/components/partials/war-room/constants';

export default Vue.extend({
  name: 'WarRoomPostPreviewImage',
  components: {
    LinkedInIcon,
    VideoIcon,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    isYoutube(): boolean {
      return this.post.content.type === postTypes.YOUTUBE;
    },
    isLinkedin(): boolean {
      return this.post.content.type === postTypes.LINKEDIN;
    },
  },
});
</script>

<style lang="scss" scoped>
.war-room-post-preview-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  flex-shrink: 0;
  width: 62px;
  height: 62px;
  background: var(--gray-03);
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid var(--gray-50-a20);

  &__picture {
    object-fit: cover;
  }

  &__icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
